import React from 'react';

export const findRowsCountInContainer = (container: HTMLDivElement): number => {
  if (container) {
    return container.querySelectorAll('[data-search-result-row]').length;
  }
  return 0;
};

export const focusRowInContainer = (container: HTMLDivElement, index: number) => {
  const rowsInContainer = container?.querySelectorAll('[data-search-result-row]');
  const rowToFocus = (rowsInContainer?.[index] || rowsInContainer?.[rowsInContainer.length - 1]) as HTMLAnchorElement;
  const focusableSelector = 'a,button,textarea';
  const firstFocusableElement = rowToFocus?.querySelector(focusableSelector) as HTMLAnchorElement;
  const isRowToFocusAnAnchor = rowToFocus?.tagName === 'A';
  isRowToFocusAnAnchor ? rowToFocus.focus() : firstFocusableElement?.focus();
};

export const findClosestContainer = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>): HTMLDivElement => {
  return event.currentTarget?.closest('[data-search-result-container]');
};
